import { NavSubItemGroup, NavSubItemGroupProps } from "@fluentui/react-nav-preview";

interface NavSubItemGroupCustomProps extends NavSubItemGroupProps {
  rcName?: string;
  theme?: string;
}

const NavSubItemGroupCustom = (props: NavSubItemGroupProps & NavSubItemGroupCustomProps) => {
  return <NavSubItemGroup {...props}/>
};

export default NavSubItemGroupCustom;